import React from "react";
import { Container } from "react-bootstrap";
import main from "../../../Asset/Mask-group.png";

const Second = () => {
  return (
    <>
      <section
        className="side-image-box-section pt-5"
        style={{ background: "var( --light-primary-bg)" }}
      >
        <Container>
          <div className="row align-items-center">
            <div className="col-xl-6 col-lg-12 order-2 order-md-1">
              <div className="info-content">
                <div className="title-paragraph">
                  AI FOR BUSINESS:
                  <br />
                  <strong>UNLOCKING NEW POSSIBILITIES</strong>
                </div>
                <p>AI is the future of technology.</p>
                <p>
                  Using Data and AI in your business can help you make quicker,
                  smarter decisions, work more efficiently, and grow faster. Our
                  custom AI solutions are here to transform your business,
                  making it smarter and more competitive.
                </p>
              </div>
            </div>
            <div className="col-xl-6 col-lg-12 order-1 order-md-2">
              <div className="info-img">
                <img alt="infoImage" src={main} className="w-100" />
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Second;
